import { render, staticRenderFns } from "./AddAniGroup.vue?vue&type=template&id=70c5f70c&scoped=true&"
import script from "./AddAniGroup.vue?vue&type=script&lang=js&"
export * from "./AddAniGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddAniGroup.vue?vue&type=style&index=0&id=70c5f70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5f70c",
  null
  
)

component.options.__file = "AddAniGroup.vue"
export default component.exports